import LegalLinks from "layout/LegalLinks";

/**
 * The legal links on phones, placed after the page content. A fixed footer
 * cost 37px on every screen; AppFooter only shows from sm.
 */
export function MobileLegalLinks(): JSX.Element {
  return (
    <nav
      aria-label="Legal"
      className="sm:hidden flex-none flex justify-center gap-6 px-3 pt-2 pb-4 text-xs"
    >
      {/* Vertical padding for a comfortable tap target on a touch screen. */}
      <LegalLinks linkClassName="py-2" />
    </nav>
  );
}

export default MobileLegalLinks;
